import { useContext } from "react"
import { Navigate } from "react-router-dom"
import { LoginContext } from "../context/LoginContext"

const PrivateRoute = ({ children }) => {
    const user = useContext(LoginContext)
    return (
        <>
            {
                !user ? <Navigate to="/auth/login" /> : children
            }
        </>
    )
}

export default PrivateRoute